<script>
import { mapStates } from "element-ui/packages/table/src/store/helper";
import { getColumnWidthStyle, getColumnClasses } from "./utils.js";

export default {
  name: "GtTableHeader",

  render(h) {
    return h(
      "div",
      {
        class: "gt-table__header"
      },
      this.columns.map((column, columnIndex) => {
        return h(
          "div",
          {
            class: [
              "gt-table__header-column",
              ...getColumnClasses({
                column,
                columnIndex
              })
            ],
            style: {
              ...getColumnWidthStyle(column)
            }
          },
          [
            h(
              "div",
              {
                class: "cell"
              },
              [
                column.renderHeader
                  ? column.renderHeader(h, {
                      $index: columnIndex,
                      column,
                      store: this.store
                    })
                  : column.label
              ]
            )
          ]
        );
      })
    );
  },

  props: {
    store: {
      required: true
    }
  },

  computed: {
    ...mapStates({
      columns: "columns"
    })
  }
};
</script>
